import React from "react";
import MobileHomeNavbar from "../MobileHomeNavbar/MobileHomeNavbar";
import MobileHomeHeroShowcase from "../MobileHomeHeroShowcase/MobileHomeHeroShowcase";
import MenFashionSection from "../../../pages/homepage/FashionProductSection/MenFashionSection/MenFashionSection";
import CustomerTestimonials from "../../../pages/homepage/Testimonials/CustomerTestimonials/CustomerTestimonials";
import SellerTestimonials from "../../../pages/homepage/Testimonials/SellerTestimonials/SellerTestimonials";
import HomeSocialMedia from "../../../pages/homepage/HomeSocialMedia/HomeSocialMedia";

interface ActiveCategorySection {
    id: string;
    name: string;
    level: "superCategory";
    superCategory?: string | null;
    count: number;
}

interface MobileHomePageProps {
    activeCategorySections: ActiveCategorySection[];
    superCategories: { _id?: string; name: string }[];
    getCategoryPromoBanner: (catName?: string) => React.ReactNode;
}

const MobileHomePage: React.FC<MobileHomePageProps> = ({
    activeCategorySections,
    superCategories,
    getCategoryPromoBanner,
}) => {
    return (
        <>
            <MobileHomeNavbar />
            <MobileHomeHeroShowcase />

            {activeCategorySections.length > 0
                ? activeCategorySections.map((cat, index) => (
                    <React.Fragment key={cat.id || index}>
                        <MenFashionSection
                            categoryName={cat.name}
                            superCategory={cat.superCategory || cat.name}
                            promoBanner={getCategoryPromoBanner(cat.name)}
                        />
                    </React.Fragment>
                ))
                : superCategories.length > 0 &&
                superCategories.map((category, index) => (
                    <React.Fragment key={category._id || index}>
                        <MenFashionSection
                            categoryName={category.name}
                            superCategory={category.name}
                            promoBanner={getCategoryPromoBanner(category.name)}
                        />
                    </React.Fragment>
                ))}

            <CustomerTestimonials />
            <SellerTestimonials />
            <HomeSocialMedia />
        </>
    );
};

export default MobileHomePage;
